
















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore } from "@/model/Model";
import { RiskLevel } from "@/model/RiskLevel";
import { Borough } from "@/model/Boroughs";

@Component
export default class UnitsExplanation extends Vue {
  public static navButtonClasses: string[] = ["what-do-units-mean"];
  public static navButtonLabel: () => string = () => "What do my units mean?";

  @Prop() public score!: number;
  @Prop() public gender!: Gender;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  private showContent: boolean = false;

  private toggleContent() {
    this.showContent = !this.showContent;
  }

  private get isFemale(): boolean {
    return this.gender === Gender.Female;
  }

  private get isLowerRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Lower;
  }

  private get isIncreasingRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Increasing;
  }

  private get isHigherRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Higher;
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }
}
